import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { Design } from '../designTest/designTest.model';
import { ChangePassword } from '../change_password/change_password.model';
import { PinCheck } from '../pin_check/pin.model';

export interface UserDetails {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  // confirmpassword: string;
  phone: string;
  type;
  exp: number;
  iat: number;
}
interface TokenResponse {
  token: string;
}

export interface Category {
  category_name: string;
}
export interface Checkqset {
  qsetname: string;
}
export interface DuplicateCollege {
  collegeid: string;
  yearid: string;
  setid: string;
}
export interface SubCategory {
  subcategory: string;
}
export interface Type {
  cate_id: string;
  subcategory_id: string;
  style_id: string;
}
export interface Complexity {
  cate_id: string;
  subcategory_id: string;
  type_id: string;
}

export interface Style {
  cate_id: string;
  subcategory_id: string;
}

export interface Item {
  questionsetname: string;
}

export interface TokenPayload {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  phone: string;
  type: string;
  // clientTime: Date;
  // clientTimezone: string;
}

export interface Question_Counter {
  Category_id : string,
  SubCategory_id: string,
  Complexity_id: string,
  type_id: string,
  style_id:string
}

export interface CandidateInformation {
  college_name: string;
  academic_year: string;

}
export interface Edit {
  email: string;
}

export interface UserType {
  type: string;
}
export interface Category_array {
  category_name: string,
  display_name: string
}
export interface User_array {
  user_name: string,
  password: string
}

export interface TestData {
  id: string;
  FirstName: string;
  LastName: string;
  Email: string;
  Phone: string;
  Type: string;
}

export interface errorData {
  phone_number: boolean;
  first_name: boolean;
  last_name: boolean;
  email: boolean;
  password: boolean;
  phone: boolean;
  email_id:boolean;
}

@Injectable()
export class AuthenticationService {
  private token: string;
  constructor(private http: HttpClient) { }
  private saveToken(token: string): void {
    localStorage.setItem('userToken', token);
    this.token = token;
    //
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('userToken');
      //
    }
    return this.token;
  }

  public getUserDetails(): UserDetails {
    const token = this.getToken();
    let payload;
    if (token) {
      //
      payload = token.split('.')[1];
      payload = window.atob(payload);
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  public isLoggedIn(): boolean {
    const user = this.getUserDetails();
    if (user) {
      return user.exp > Date.now() / 1000;
    } else {
      return false;
    }
  }

  setCurrentUser(user) {
    user.isLoggedIn = true;
    user.first_name = user.getUserDetails.first_name;
    user.last_name = user.getUserDetails.last_name;
    user.email = user.getUserDetails.email;
    user.phone = user.getUserDetails.phone;
    user.type = user.getUserDetails.type;
  }

  // UI
  getColumns(): string[] {
    return ['DEPT', 'ROLL-NO', 'NAME', 'DOB', '10TH_MARK', '12TH_MARK', 'CGPA'];
  }
  getColumnsB(): string[] {
    return ['FIRST NAME', 'LAST NAME', 'E-MAIL', 'PHONE NUMBER', 'EDIT', 'DELETE'];
  }
  getSAColumns(): string[] {
    return ['FIRST NAME', 'LAST NAME', 'E-MAIL', 'PHONE NUMBER', 'EDIT'];
  }

  // Register
  public register(user: TokenPayload): Observable<any> {
    //

    const b = this.http.post('/users/register', user);
    const request = b.pipe(
      map((data: TokenResponse) => {


        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  // Login....
  public login(user: TokenPayload): Observable<any> {
    console.log("Login Service::::::::::::::::",user)
    const base = this.http.post('/users/login', user);

    const request = base.pipe(
      map((data: TokenResponse) => {
        return data;
      })
    );
    return request;
  }

   // Login....
   public logout(user: TokenPayload): Observable<any> {

    const base = this.http.post('/users/login/logout',user);


    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }

        return data;
      })
    );
    return request;
  }


  // change password..........
  public changepassword(user: ChangePassword): Observable<any> {

    const base = this.http.post('/users/password', user);


    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }

        return data;
      })
    );
    return request;
  }

  // reset password......
  public resetpassword(user: ChangePassword): Observable<any> {

    const base = this.http.post('/users/password/reset', user);


    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }

        return data;
      })
    );
    return request;
  }

  // forgot password.........
  public forgotpassword(user: ChangePassword,hostname): Observable<any> {

    console.log("Printing the HostName in auth service ",hostname);
    var temp = { user, hostname };
    const base = this.http.post('/users/password/forgot_password', temp);


    const request = base.pipe(
      map((data: TokenResponse) => {



        return data;
      })
    );
    return request;
  }

  // check pin number......
  public checkpin(user: PinCheck): Observable<any> {

    const base = this.http.post('/users/password/check_pin', user);


    const request = base.pipe(
      map((data: TokenResponse) => {



        return data;
      })
    );
    return request;
  }

  // upload candidate info
  public uploadinfo(user): Observable<any> {


    const b = this.http.post('/users/uploadinfo', user);
    const request = b.pipe(
      map((data: TokenResponse) => {


        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  
  // checkEmail(email) {
  //   console.log("email",email)
  //   return this.http.get(`/users/user_details/checkEmail?email=${email}`);
  // }

     // get User Details
     public checkEmail(email: string): Observable<any> {
      console.log("inside check",email)
      const base = this.http.get(`/users/password/checkEmail?email=${email}`);
      const request = base.pipe(
        map((data: TokenResponse) => {
          return data;
        })
      );
      return request;
    }


  // // createAdmin
  //   public createAdmin(user: TokenPayload): Observable<any> {
  //     const b = this.http.post('/users/createAdmin', user);
  //     const request = b.pipe(
  //       map((data: TokenResponse) => {
  //

  //         if (data.token) {
  //           this.saveToken(data.token);
  //         }
  //         return data;
  //       })
  //     );
  //     return request;
  //   }

  // // CreateTestScheduler
  //   public createTestScheduler(user: TokenPayload): Observable<any> {
  //     const b = this.http.post('/users/createTestScheduler', user);
  //     const request = b.pipe(
  //       map((data: TokenResponse) => {
  //

  //         if (data.token) {
  //           this.saveToken(data.token);
  //         }
  //         return data;
  //       })
  //     );
  //     return request;
  //   }

  // // CreateTestTaker
  //   public createTestTaker(user: TokenPayload): Observable<any> {
  //     const b = this.http.post('/users/createTestTaker', user);
  //     const request = b.pipe(
  //       map((data: TokenResponse) => {
  //

  //         if (data.token) {
  //           this.saveToken(data.token);
  //         }
  //         return data;
  //       })
  //     );
  //     return request;
  //   }


  // display super-admin
  public superadmin(user: TestData): Observable<any> {
    const base = this.http.get('/users/superadmin');

    const request = base.pipe(
      map((data: TokenResponse) => {


        return data;
      })
    );
    return request;
  }

  //  // display admin:
  //   public admin(user: TestData): Observable<any> {
  //     const base = this.http.post('/users/admin', user);
  //     //
  //     const request = base.pipe(
  //       map((data: TokenResponse) => {
  //
  //
  //         // if (data.token) {
  //         //   this.saveToken(data.token);
  //         // }
  //         return data;
  //       })
  //     );
  //     return request;
  //   }

  // // display test_scheduler:
  // public test_scheduler(user: TestData): Observable<any> {
  //   const base = this.http.post('/users/test_scheduler', user);
  //   //
  //   const request = base.pipe(
  //     map((data: TokenResponse) => {
  //
  //
  //       // if (data.token) {
  //       //   this.saveToken(data.token);
  //       // }
  //       return data;
  //     })
  //   );
  //   return request;
  // }

  //  // display test_taker:
  //  public test_taker(user: TestData): Observable<any> {
  //   const base = this.http.post('/users/test_taker', user);
  //   //
  //   const request = base.pipe(
  //     map((data: TokenResponse) => {
  //
  //
  //       // if (data.token) {
  //       //   this.saveToken(data.token);
  //       // }
  //       return data;
  //     })
  //   );
  //   return request;
  // }

  // dashboard
  public dashboard(user: TokenPayload): Observable<any> {

    const base = this.http.post('/users/dashboard', user);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }



  //display category
  // delete
  public get_category(user: TestData): Observable<any> {

    const base = this.http.post('/users/getcategory', user);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  // terminate user
  public terminateuser(user: User_array): Observable<any> {

    const base = this.http.post('/users/terminate', user);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

    // giveReAccess to user
    public giveReAccess(user: User_array): Observable<any> {

      const base = this.http.post('/users/terminate/giveReAccess', user);
  
      const request = base.pipe(
        map((data: TokenResponse) => {
  
          //
          if (data.token) {
            this.saveToken(data.token);
          }
          return data;
        })
      );
      return request;
    }

  //check userid if exists
  public check_user(user: User_array): Observable<any> {

    const base = this.http.post('/users/terminate/check_user', user);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  // display user edit details
  public edit1(user: TokenPayload): Observable<any> {

    const base = this.http.post('/users/edit1', user);

    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  // get user type.........
  public get_user_type(id): Observable<any> {

    var body = {
      id: id
    }
    const base = this.http.post('/users/get_type', body);
    const request = base.pipe(
      map((data: TokenResponse) => {

        //
        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }




  // update admin and superadmin........
  public update(user: TokenPayload): Observable<any> {

    const b = this.http.post('/users/edit', user);
    const request = b.pipe(
      map((data: TokenResponse) => {

        if (data.token) {
          this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }


  // Design...........
  public designTest(item: Array<Design>,name): Observable<any> {
   var temp ={
    item:item,
    name:name
   }
   console.log("temp",temp)
    const b = this.http.post('/users/question_set', temp);
   
    const request = b.pipe(
      map((data: TokenResponse) => {

        
        console.log("data in authentication service",data)
        return data;
      })
    );
    return request;
  }

  //check for duplicate set..........
  // Design
  public check_qset(item: Checkqset): Observable<any> {

    const b = this.http.post('/users/question_set/duplicate_set', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        console.log(data,"data dupqn")
        return data;
      })
    );
    return request;
  }

  //check for duplicate college
  // Design
  public duplicatecollege(item: DuplicateCollege): Observable<any> {

    const b = this.http.post('/users/schedule/duplicate_schedule', item);
    const request = b.pipe(
      map((data: TokenResponse) => {

        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // question category........
  public category(user: Category): Observable<any> {
   console.log("userrrr",user);
    const base = this.http.post('/users/question_set/category', user);

    const request = base.pipe(
      map((data: TokenResponse) => {
        return data;
      })
    );
    return request;
  }

   // question section_name......
   public section_name(user: Category): Observable<any> {

    const base = this.http.post('/users/question_set/section_name', user);

    const request = base.pipe(
      map((data: TokenResponse) => {
     console.log(data,"secdata")

        return data;
      })
    );
    return request;
  }

  // question subcategory.....
  public subcategory(user: Category): Observable<any> {
console.log("user",user)
    const base = this.http.post('/users/question_set/subcategory', user);

    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  // question category
  // public sub_category(id: Category): Observable<any> {
  //
  //   var body = {
  //     id: id
  //   };
  //   const base = this.http.post('/users/sub_category', body);
  //
  //   const request = base.pipe(
  //     map((data: TokenResponse) => {
  //
  //
  //       // if (data.token) {
  //       //   this.saveToken(data.token);
  //       // }
  //       return data;
  //     })
  //   );
  //   return request;
  // }

  // question type...
  public type(user: Type): Observable<any> {

    console.log("Printing the user type data ",user);

    const base = this.http.post('/users/question_set/type', user);

    
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  public style(user: Style): Observable<any> {
    
console.log("User in Service : ",user);
    const base = this.http.post('/users/question_set/style', user);

    
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }


  public getComplexityTypes(): Observable<any> {

    const base = this.http.get('/users/question_set/types');

    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }

  
  
  //MCQ_WITH_IMAGES sub category sets up options in all 6 Answer text boxes

  public MCQcategory(): Observable<any> {

    const base = this.http.get('/users/question_set/MCQcategory');

    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }


  public MCQsubcategory(): Observable<any> {

    const base = this.http.get('/users/question_set/MCQsubcategory');

    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }


  public MCQtype(): Observable<any> {

    const base = this.http.get('/users/question_set/MCQtype');

    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }


  public MCQstyle(): Observable<any> {

    const base = this.http.get('/users/question_set/MCQstyle');

    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }





  // Count of questions for selected subcategory......
  public subcategory_count(user: Question_Counter): Observable<any> {
     console.log("user in authservice",user);
    const base = this.http.post('/users/question_set/subcategory_count', user);

    const request = base.pipe(
      map((data: TokenResponse) => {
        console.log("data in auth",data);
        return data;
       
      })
    );
    return request;
  }



  // question complexity....
  public complexity(user: Complexity): Observable<any> {
console.log("comuser",user);
    const base = this.http.post('/users/question_set/complexity', user);

    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }



}



